// BioAgeCard.jsx

import React from "react";
import BasePackageCard from "./BasePackageCard";
import { BIOAGE } from "../../../../constants";
import { useTranslation } from "../../../../language";

export default function BioAgeCard() {
  const { t } = useTranslation();

  const panel = {
    id: "bioage",
    title: t("card_bio_age_title"),
    subtitle: t("card_bio_age_desc"),
    biomarkers: t("card_bio_age_markers"),
    price: "€ 19",
    image: BIOAGE,
    rawMarkers: true,
  };

  return <BasePackageCard panel={panel} />;
}